export enum NavIds {
  ScrubHandle = 'progress-bar-handle',
  CCButton = 'progress-bar-cc-button',
  ShowPoster = 'progress-bar-show-poster',
  ControlButton = 'video-control-button',
  AdControls = 'ad-overlay-number',
  DefaultFocus = 'video-control-button',
  LiveCarousel = 'live-carousel',
  ScheduleButton = 'schedule-button',
  LiveGenreSelector = 'live-genre-selector',
}
